// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

// 👇 NOWE IMPORTY STRIPE
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const store = configureStore({ reducer: rootReducer, devTools: true });

// 👇 Inicjalizacja Stripe – użyj klucza publicznego z ENV
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        {/* 👇 Owijamy całą aplikację w Elements */}
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
